import Checkbox from "@mui/material/Checkbox";
import { useEffect, useState } from "react";
import { withStyles } from "@mui/styles";
import PropTypes from "prop-types";

const fontColor = "#0061a9";
const bgColor = "#E5EFF6";

const StyledCheckbox = withStyles((theme) => ({
  root: {
    color: fontColor,
    "& .MuiIconButton-label": {
      position: "relative",
      zIndex: 0,
    },
    "&:hover": {
      backgroundColor: bgColor,
      "@media (hover: none)": {
        backgroundColor: "transparent",
      },
    },
    "&$checked:hover": {
      backgroundColor: bgColor,
      "@media (hover: none)": {
        backgroundColor: "transparent",
      },
    },
    "&$checked, &$checked .MuiButtonBase-root": {
      color: fontColor,
    },
    "&:not($checked), &:not($checked) .MuiButtonBase-root": {
      color: fontColor,
    },
    "& .MuiSvgIcon-root": {
      width: "1.25em",
      height: "1.25em",
    },
  },
  checked: {
    color: fontColor,
    "& .MuiIconButton-label": {
      position: "relative",
      zIndex: 0,
    },
    "&:hover": {
      backgroundColor: bgColor,
      "@media (hover: none)": {
        backgroundColor: "transparent",
      },
    },
    "&$checked, &$checked .MuiButtonBase-root": {
      color: fontColor,
    },
    "&:not($checked), &:not($checked) .MuiButtonBase-root": {
      color: fontColor,
    },
    "& .MuiSvgIcon-root": {
      width: "1.25em",
      height: "1.25em",
    },
  },
}))(Checkbox);

export default function FormCheckBox(props) {
  const [checked, setCheck] = useState(false);
  let [hasError, setErrorState] = useState(false);
  let [firstFocus, setfirstFocus] = useState(false); //Only run validation on fields that have already been visited
  useEffect(() => {
    if (props.onFieldErrorCleared) {
      setfirstFocus(true);
    }
    if (!checked && props.onFieldError && firstFocus) {
      setErrorState(true);
      props.onFieldError(props.name);
    }
    if (checked && props.onFieldErrorCleared) {
      setErrorState(false);
      props.onFieldErrorCleared(props.name);
    }
  }, [props.forceErrorCheck]);

  const checkChanged = (checked) => {
    if (!firstFocus) {
      setfirstFocus(true);
    }
    setCheck(checked);
    props.onChange && props.onChange(props.name, checked, false);
    if (checked && hasError) {
      setErrorState(false);
      props.onFieldErrorCleared(props.name);
    }
  };

  return (
    <div className="check-box">
      <div className="box">
        <StyledCheckbox
          checked={checked}
          onChange={(e) => checkChanged(e.target.checked)}
        />
      </div>
      <div className="text">{props.text}</div>
      {hasError && (
        <div className="error">
          <p>{props.errMessage}</p>
        </div>
      )}
    </div>
  );
}

FormCheckBox.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  name: PropTypes.string.isRequired,
  forceErrorCheck: PropTypes.bool,
  onFieldError: PropTypes.func,
  onFieldErrorCleared: PropTypes.func,
  errMessage: PropTypes.string,
  onChange: PropTypes.func,
};
